import React from "react";
import styles from "./Chilling.module.css";
import ProductDetailsComponent from "../../../../../components/ProductDetailsComponent/ProductDetailsComponent";
import CheckListComponent from "../../../../../components/CheckListComponent/CheckListComponent";

const Chilling = () => {
  const Options = [
    { title: "Mixer sanitized prior to use  " },
    { title: "Ingredient scale calibrated" },
    { title: "Water measurement double-checked" },
    { title: "Verify ingredient temperature before mixing (if applicable)" },
    { title: "Record lot numbers for traceability (if required)" },
    { title: "No food or drink in the areas" },
  ];

 

  return (
    <div className={styles.MainCont}>
      <div className={styles.RightCont}>
        <CheckListComponent Options={Options} Heading={"GMP"} />
      </div>
    </div>
  );
};

export default Chilling;
